import { StyleSheet } from 'aphrodite'
export default StyleSheet.create({
  form: {
    maxWidth: '40em',
    margin: '2em auto',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  formGroup: {
    marginBottom: '1em',
    width: '16em',
  },
  formGroupBtn: {
    marginBottom: '1em',
    width: '16em',
    paddingTop: '1.5em',
  },

  button: {
    width: '100%',
  },
  select: {
    height: '2em',
  },

  inputSelect: {
    width: '100%',
    height: '2em',
  },
})
